import React from 'react';

import DataGrid from '@gogame/data-grid';
import { useScreenDispatch, useScreenState } from '@gogame/screens';
import { useLoadSkanSchemes } from 'scenes/SkanSchemes/data';
import {
  COLUMN_ID,
  COLUMN_APPLICATION,
  COLUMN_LAST_UPDATED,
  COLUMN_LAST_UPDATED_BY,
  COLUMN_CREATED,
  COLUMN_CREATED_BY,
} from 'scenes/SkanSchemes/constants';
import {
  SET_TABLE_SETTINGS,
  COLLAPSE_COLUMNS,
  REORDER_COLUMNS,
} from 'scenes/SkanSchemes/screenReducer';

import SkanSchemesToolbar from './SkanSchemesToolbar';

import { SkanSchemesActions } from '../Actions';
import { SkanSchemeDetailsLink } from './SkanSchemeDetailsLink';
const SkanSchemesDataTable = () => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();
  const { data, isLoading, isRefetching } = useLoadSkanSchemes({
    ...screenState.tableSettings,
  });

  const handleChangeSettings = (settings) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: settings,
    });
  };

  const handleReorder = (order) => {
    dispatch({
      type: REORDER_COLUMNS,
      payload: order,
    });
  };

  const handleCollapse = (collapsed) => {
    dispatch({
      type: COLLAPSE_COLUMNS,
      payload: collapsed,
    });
  };
  const getRowId = (row) => row[COLUMN_ID];

  return (
    <React.Fragment>
      <DataGrid
        rows={data?.rows}
        count={data?.count}
        loading={isLoading}
        fetching={isRefetching}
        ready={screenState.ready}
        onChangeSettings={handleChangeSettings}
        onReorder={handleReorder}
        onCollapse={handleCollapse}
        tableSettings={screenState.tableSettings}
        columnsState={screenState.columns}
        toolbar={<SkanSchemesToolbar />}
        storageKey={'skan-schemes'}
        defaultColumnWidth={120}
        filtered={!!screenState.searchQuery}
        getRowId={getRowId}
      >
        <DataGrid.Column
          field={COLUMN_ID}
          type={'text'}
          headerName={'ID'}
          align={'right'}
          headerAlign={'right'}
          width={80}
          fixed={true}
          resizable={false}
        />
        <DataGrid.Column
          field={COLUMN_APPLICATION}
          type={'link'}
          headerName={'Application'}
          flex={1}
          linkComponent={SkanSchemeDetailsLink}
          getTooltip={(v) => v}
        />
        <DataGrid.Column
          field={COLUMN_LAST_UPDATED}
          type={'date'}
          template={'LLL'}
          headerName={'Last Updated'}
          flex={1}
        />
        <DataGrid.Column
          field={COLUMN_LAST_UPDATED_BY}
          type={'text'}
          headerName={'Last Updated by'}
          flex={1}
        />
        <DataGrid.Column
          field={COLUMN_CREATED}
          type={'date'}
          template={'LLL'}
          headerName={'Created'}
          flex={1}
        />
        <DataGrid.Column
          field={COLUMN_CREATED_BY}
          type={'text'}
          template={'LLL'}
          headerName={'Created by'}
          flex={1}
        />
        <DataGrid.Column
          actionsColDef
          type={'actions'}
          actionsComponent={SkanSchemesActions}
        />
      </DataGrid>
    </React.Fragment>
  );
};

export default SkanSchemesDataTable;
